const phoneNumberValidator = (message = "Invalid format") => function(value, state) {
  if (value && value.length < 10) {
    return message;
  }

  return null;
};

export default phoneNumberValidator;
